module.exports = __webpack_public_path__ + "img/185.776490f6.jpg";